export const ME = 'USER_ME'
export const ON_LOAD = 'ON_LOAD'
export const CSV_FILE = 'CSV_FILE'
export const SET_ROLES = 'SET_ROLES'
export const LOADING = 'USER_LOADING'
export const SET_USER = 'USER_SET_USER'
export const SET_USERS = 'USER_SET_USERS'
export const RESET_FILTERS = 'REST_FILTERS'
export const SELECT_ROLES = 'SELECT_ROLES'
export const RESET_USER = 'USER_RESET_USER'
export const REMOVE_FILTER = 'REMOVE_FILTER'
export const SET_STORES = 'STORE_SET_STORES'
export const USER_ON_CHANGE = 'USER_ON_CHANGE'
export const SET_USER_ROLES = 'SET_USER_ROLES'
export const SEARCH_USERS = 'USER_SEARCH_USERS'
export const SET_USER_GROUPS = 'SET_USER_GROUPS'
export const SELECT_STORE = 'STORE_SELECT_STORE'
export const SELECT_COURSE = 'USER_SELECT_COURSE'
export const LAST_ACTIVITY = 'USER_LAST_ACTIVITY'
export const SET_USER_REWARDS = 'SET_USER_REWARDS'
export const SET_ACTIVE_PAGES = 'SET_ACTIVE_PAGES'
export const SET_EMAIL_FILTER = 'SET_EMAIL_FILTER'
export const SET_USER_DETAILS = 'SET_USER_DETAILS'
export const UPLOAD_CSV_STATUS = 'UPLOAD_CSV_STATUS'
export const SET_USER_ARCHIVED = 'SET_USER_ARCHIVED'
export const USER_PROFILE_SAVE = 'USER_PROFILE_SAVE'
export const UPLOAD_CSV_PERCENT = 'UPLOAD_CSV_PERCENT'
export const SET_USER_LOCATIONS = 'SET_USER_LOCATIONS'
export const SET_USER_REGIONS = 'SET_USER_REGIONS'
export const USER_PASSWORD_SAVE = 'USER_PASSWORD_SAVE'
export const SET_LOCK_USER_DATA = 'SET_LOCK_USER_DATA'
export const SET_ACTIVE_FILTERS = 'SET_ACTIVE_FILTERS'
export const SET_ARCHIVED_FILTER = 'SET_ARCHIVED_FILTER'
export const SET_ARCHIVED_FILTER_TRUE = 'SET_ARCHIVED_FILTER_TRUE '
export const SET_USER_PRIVILEGES = 'SET_USER_PRIVILEGES'
export const SET_USERS_ROWS_DATA = 'SET_USERS_ROWS_DATA'
export const SET_USERNAME_FILTER = 'SET_USERNAME_FILTER'
export const SET_TOGGLE_ARCHIVED = 'SET_TOGGLE_ARCHIVED'
export const SET_USER_SUBMISSIONS = 'SET_USER_SUBMISSIONS'
export const SET_USERS_DETAILS = 'USERS_SET_USERS_DETAILS'
export const SET_ASSIGNABLE_USERS = 'SET_ASSIGNABLE_USERS'
export const USER_PASSWORD_CHANGE = 'USER_PASSWORD_CHANGE'
export const SET_LAST_NAME_FILTER = 'SET_LAST_NAME_FILTER'
export const SET_EXTRA_FIELD_1_FILTER = 'SET_EXTRA_FIELD_1_FILTER'
export const SET_EXTRA_FIELD_2_FILTER = 'SET_EXTRA_FIELD_2_FILTER'
export const SET_LAST_LOGIN_FILTER = 'SET_LAST_LOGIN_FILTER'
export const SET_FIRST_NAME_FILTER = 'SET_FIRST_NAME_FILTER'
export const SET_USERS_COLUMN_DATA = 'SET_USERS_COLUMN_DATA'
export const TOGGLE_ARCHIVED_USERS = 'TOGGLE_ARCHIVED_USERS'
export const SET_HAS_ACTIVE_FILTERS = 'SET_HAS_ACTIVE_FILTERS'
export const MERGE_GROUPS_LOCATIONS = 'MERGE_GROUPS_LOCATIONS'
export const CURRENT_USER_ON_CHANGE = 'CURRENT_USER_ON_CHANGE'
export const SET_USERS_HAVE_CHANGES = 'SET_USERS_HAVE_CHANGES'
export const SET_EXTERNAL_ID_FILTER = 'SET_EXTERNAL_ID_FILTER'
export const SET_SHOW_ARCHIVED_USERS = 'SET_SHOW_ARCHIVED_USERS'
export const TOGGLE_TEERMINATED_USERS = 'TOGGLE_TEERMINATED_USERS'
export const SET_TOGGLE_SECOND_ACCESS = 'SET_TOGGLE_SECOND_ACCESS'
export const SET_TOGGLE_LOCK_USER_DATA = 'SET_TOGGLE_LOCK_USER_DATA'
export const SET_TOTAL_NUMBER_OF_USERS = 'SET_TOTAL_NUMBER_OF_USERS'
export const SET_SELECTED_ROLES_FILTER = 'SET_SELECTED_ROLES_FILTER'
export const SET_SELECTED_ACCESS_FILTER = 'SET_SELECTED_ACCESS_FILTER'
export const SET_SELECTED_STORES_FILTER = 'SET_SELECTED_STORES_FILTER'
export const SET_SELECTED_STATUS_FILTER = 'SET_SELECTED_STATUS_FILTER'
export const SELECT_SECOND_ACCESS_STORE = 'SELECT_SECOND_ACCESS_STORE'
export const SET_USERS_EXTENDED_DETAILS = 'SET_USERS_EXTENDED_DETAILS'
export const SET_TOTAL_PAGINATION_PAGES = 'SET_TOTAL_PAGINATION_PAGES'
export const SET_SELECTED_SECOND_ACCESS = 'SET_SELECTED_SECOND_ACCESS'
export const SET_CURRENT_PAGINATION_PAGE = 'SET_CURRENT_PAGINATION_PAGE'
export const SET_SHOW_SELECTED_USERS_ITEMS = 'SET_SHOW_SELECTED_USERS_ITEMS'
export const SET_CURRENT_PAGINATION_OFFSET = 'SET_CURRENT_PAGINATION_OFFSET'
export const SET_USER_BIRTHDATE = 'SET_USER_BIRTHDATE'
export const SET_USER_LAST_HIRE_DATE = 'SET_USER_LAST_HIRE_DATE'
export const SET_WELCOME_EMAIL_BUTTON_DISABLED =
  'SET_WELCOME_EMAIL_BUTTON_DISABLED'
export const SET_SELECTED_LOCATION_GROUPS_FILTER =
  'SET_SELECTED_LOCATION_GROUPS_FILTER'
export const SET_ARCHIVED_USERS = 'SET_ARCHIVED_USERS'

export const SET_MANAGER_APPROVAL_USERS = 'SET_MANAGER_APPROVAL_USERS'
export const SET_GROUP_MANAGER_APPROVAL_USERS =
  'SET_GROUP_MANAGER_APPROVAL_USERS'

export const SELECT_EXTERNAL_REPORT = 'SELECT_EXTERNAL_REPORT'

export const SET_ROLE_SWITCH = 'SET_ROLE_SWITCH'
export const SET_ROLE_SWITCH_FROM_BACK = 'SET_ROLE_SWITCH_FROM_BACK'
export const SET_FEED_IGNORE_FROM_BACK = 'SET_FEED_IGNORE_FROM_BACK'

export const SET_IGNORE_FEED = 'SET_IGNORE_FEED'
export const USER_AVATAR = 'USER_AVATAR'

export const SET_CREATING_LOADING = 'SET_CREATING_LOADING'
export const SEND_WELCOME_EMAIL_TO_ALL = 'SEND_WELCOME_EMAIL_TO_ALL'

export const TOGGLE_MODAL = 'TOGGLE_MODAL'
export const SET_SELECTED_ORG_GROUPS = 'SET_SELECTED_ORG_GROUPS'
export const SET_SELECTED_USERS = 'SET_SELECTED_USERS'
export const SET_SELECTED_LOCATION_GROUPS = 'SET_SELECTED_LOCATION_GROUPS'
export const SET_SELECTED_LOCATIONS = 'SET_SELECTED_LOCATIONS'
export const SET_SELECTED_STORES = 'SET_SELECTED_STORES'
export const SET_SELECTED_ROLES = 'SET_SELECTED_ROLES'
export const SET_SHOW_SELECTED_ORG_GROUPS = 'SET_SHOW_SELECTED_ORG_GROUPS'
export const SET_SHOW_SELECTED_USERS = 'SET_SHOW_SELECTED_USERS'
export const SET_SHOW_SELECTED_LOCATIONS = 'SET_SHOW_SELECTED_LOCATIONS'
export const SET_SHOW_SELECTED_LOCATION_GROUPS =
  'SET_SHOW_SELECTED_LOCATION_GROUPS'
export const SET_SHOW_SELECTED_ROLES = 'SET_SHOW_SELECTED_ROLES'
export const SET_SHOW_SELECTED_STORES = 'SET_SHOW_SELECTED_STORES'
export const RESET_SELECTED_ITEMS = 'RESET_SELECTED_ITEMS'
export const SET_CURRENT_SELECTED_ITEMS = 'SET_CURRENT_SELECTED_ITEMS'
export const SET_CURRENT_SHOW_SELECTED_ITEMS = 'SET_CURRENT_SHOW_SELECTED_ITEMS'
export const SET_CURRENT_HIDE_SELECTED_ITEMS_FUNCTION =
  'SET_CURRENT_HIDE_SELECTED_ITEMS_FUNCTION'
export const SET_CURRENT_SHOW_SELECTED_ITEMS_FUNCTION =
  'SET_CURRENT_SHOW_SELECTED_ITEMS_FUNCTION'
export const SET_CURRENT_ITEMS = 'SET_CURRENT_ITEMS'
export const SET_CURRENT_TAB = 'SET_CURRENT_TAB'
export const SET_CURRENT_TOGGLE_ITEM_FUNCTION =
  'SET_CURRENT_TOGGLE_ITEM_FUNCTION'
export const SET_ASSIGN_SEARCH_VALUE = 'SET_ASSIGN_SEARCH_VALUE'
export const ON_CHANGE_EMAIL_BODY = 'ON_CHANGE_EMAIL_BODY'
export const ON_CHANGE_EMAIL_SUBJECT = 'ON_CHANGE_EMAIL_SUBJECT'
export const ON_CHANGE_WELCOME_EMAIL_SUBJECT = 'ON_CHANGE_WELCOME_EMAIL_SUBJECT'
export const ON_CHANGE_WELCOME_EMAIL_BODY = 'ON_CHANGE_WELCOME_EMAIL_BODY'
export const TOGGLE_SHOW_IN_MANAGER_REPORT = 'TOGGLE_SHOW_IN_MANAGER_REPORT'
export const SET_SHOW_IN_MANAGER_REPORT = 'SET_SHOW_IN_MANAGER_REPORT'
export const SET_NOT_LOGGED_IN_USERS = 'SET_NOT_LOGGED_IN_USERS'
export const SET_WELCOME_EMAIL_TEMPLATE = 'SET_WELCOME_EMAIL_TEMPLATE'
